import {createAction, props} from "@ngrx/store";
import {InfoSideMenuItem} from "../../interfaces/info-side-menu-item";

export const setSideMenuItems = createAction(
  '[Page] Set Side Menu Items',
  props<{ sideMenuItems: InfoSideMenuItem[] }>()
);

export const setPageLinkPrefix = createAction(
  '[Page] Set Page Link Prefix',
  props<{ prefix: string }>()
);

export const setArchiveSortState = createAction(
  '[Page] Set Archive Sort Element visibility',
  props<{ state: boolean }>()
)
